import AxiosInstance from "../Utils/axios/axiosConfig";

const getPosData = async () => {
  const response = await AxiosInstance.get("/pos/");
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

const getPosDetails = async (po = "") => {
  
  const response = await AxiosInstance.get("/pos/", {
    params: { number: po },
  });
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const editPo = async (poNo = "", body = {}) => {
 
  const response = await AxiosInstance.put("/pos/", body, {
    params: { number: poNo },
  });
 
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const addPo = async (body = {}) => {
  const response = await AxiosInstance.post(`/pos/`, body);
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

const getOrdersData = async () => {
  const response = await AxiosInstance.get("/orders/");
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

const getOrderDetails = async (orderNo = "") => {
  const response = await AxiosInstance.get("/orders/", {
    params: { number: orderNo },
  });
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }
};

const postOrder = async (data,isDummy) => {
  const response = await AxiosInstance.post(`/orders/${isDummy?'?batch':''}`, data);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }
};

const addDummyOrders = async (orderData) => {
const response = await AxiosInstance.post(`/orders/?batch`, orderData);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }

};

const deleteOrder = async (orderNo = "") => {
  const response = await AxiosInstance.delete("/orders/", {
    params: { number: orderNo },
  });
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }
};

const updateOrder = async (orderNo = "", body = {}, orderType) => {
  let response;
  if (orderType === "orderRecord") {
    response = await AxiosInstance.put(`/orders/?number=${orderNo}`, body);
  } else {
    response = await AxiosInstance.put(
      `/deckle-match-order-details/?number=${orderNo}`,
      body
    );
  }

  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const restoreOrder = async (orderNo = "", body = {}, orderType) => {
  let response;
  if (orderType === "orderRecord") {
    response = await AxiosInstance.put(`/orders/?restore&number=${orderNo}`, body);
  } else {
    response = await AxiosInstance.put(
      `/deckle-match-order-details/?number=${orderNo}`,
      body
    );
  }

  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const updateIncompleteOrder = async (body = {}) => {
  const response = await AxiosInstance.put(`/incomplete-orders/`, body);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

// New API:::
const getOrdersList = async (value) => {
  const searchParams = { orders: value };
  const response = await AxiosInstance.post(
    `/deckle-match-order-details/?get&algorithm_data`,
    searchParams
  );
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const getAllOrders = async () => {
  const response = await AxiosInstance.get("/deckle-match-order-details/");
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const getDeckleOrderDetails = async (orderNo = "") => {
  const response = await AxiosInstance.get("/deckle-match-order-details/", {
    params: { number: orderNo },
  });
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const getDeckleOrderByPo = async (poNo = "") => {
  const response = await AxiosInstance.get("/deckle-match-order-details/", {
    params: { po: poNo },
  });
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const getDeckleOrdersList = async (
  params,
  sortParams,
  type,
  source,
  orderType = "both"
) => {
  let response;
  const start = (params?.page - 1) * params?.size;
  const end = start + params?.size * 1;
  if (type && params && !sortParams) {
    if (source) {
      response = await AxiosInstance.get(
        `/deckle-match-order-details/?type=${type}&exclude_group_info&start=${params?.start}&end=${params?.end}&order_type=${orderType}`,
        { cancelToken: source.token }
      );
    } else {
      response = await AxiosInstance.get(
        `/deckle-match-order-details/?type=${type}`
      );
    }
  } else if (!params) {
    response = await AxiosInstance.get("/deckle-match-order-details/");
  } else if (type && sortParams) {
    // if(source && params){
    //   response = await AxiosInstance.get(
    //     `/deckle-match-order-details/?type=${type}&exclude_group_info&start=${params?.start}&end=${params?.end}`
    //   );
    // } else
    if ((type === "incomplete_orders" || type == "planned_orders" || type == "pending_for_deckle_match") && orderType
    ) {
      response = await AxiosInstance.get(
        `/deckle-match-order-details/?type=${type}&start=${start}&end=${end}&sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}&order_type=${orderType}`
      );
    } else
      response = await AxiosInstance.get(
        `/deckle-match-order-details/?type=${type}&start=${start}&end=${end}&sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}`
      );
  } else if (sortParams) {
    response = await AxiosInstance.get(
      `/deckle-match-order-details/?start=${start}&end=${end}&sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}`
    );
  } else {
    response = await AxiosInstance.get(
      `/deckle-match-order-details/?start=${start}&end=${end}`
    );
  }
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

const getAllOrdersList = async (
  params,
  sortParams,
  state,
  source = undefined
) => {
  let response;
  const start = (params?.page - 1) * params?.size;
  const end = start + params?.size * 1;
  if (params && sortParams && state && source) {
    response = await AxiosInstance.get(
      `/order-details/?state=${state}&start=${params.start}&end=${params.end}&sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}`,
      { cancelToken: source.token }
    );
  } else if (state === "" && params && sortParams && source) {
    response = await AxiosInstance.get(
      `/order-details/?start=${params.start}&end=${params.end}&sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}`,
      { cancelToken: source.token }
    );
  } else if (!params)
    response = await AxiosInstance.get("/order-details/", {
      cancelToken: source.token,
    });
  else if (state && sortParams) {
    response = await AxiosInstance.get(
      `/order-details/?state=${state}&start=${start}&end=${end}&sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}`
    );
  } else if (state) {
    response = await AxiosInstance.get(
      `/order-details/?state=${state}&start=${start}&end=${end}`
    );
  } else if (sortParams) {
    response = await AxiosInstance.get(
      `/order-details/?start=${start}&end=${end}&sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}`
    );
  } else if (params) {
    if (source)
      response = await AxiosInstance.get(`/order-details/?state=${params}`, {
        cancelToken: source.token,
      });
    else response = await AxiosInstance.get(`/order-details/?state=${params}`);
  } else {
    response = await AxiosInstance.get(
      `/order-details/?start=${start}&end=${end}`
    );
  }
  if (!response.data.error) {
    response.data.data["state"] = state;
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

const getAllOrdersListByOrderno = async (orderNo = "") => {
  const response = await AxiosInstance.get("/order-details/", {
    params: { number: orderNo },
  });
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const getAllOrdersListByPono = async (poNo = "") => {
  const response = await AxiosInstance.get("/order-details/", {
    params: { po: poNo },
  });
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const rejectOrApproveOrder = async (orderNo = "", body = {}) => {
  const response = await AxiosInstance.put(
    `/order-states/?number=${orderNo}`,
    body
  );
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const bulkChangeOrderState = async (body = []) => {
  const response = await AxiosInstance.put("/order-states/?bulk", body);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const deletePo = async (poNumber = "") => {
  const response = await AxiosInstance.delete("/pos/", {
    params: { number: poNumber },
  });
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }
};

const poExists = async (poNumber = "") => {
  const response = await AxiosInstance.get("/pos/?exists", {
    params: { number: poNumber },
  });
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }
};

const searchOrderRecords = async (
  pattern = "",
  state,
  source = undefined,
  sortParams = {},
  pageParams = {}
) => {
  let response;
  if (state) {
    if (source) {
      response = await AxiosInstance.get("/order-details/?search", {
        params: {
          type: "contains",
          pattern: pattern,
          state: state,
          sort_by: sortParams?.sort_by,
          sort_type: sortParams?.sort_type,
          start: pageParams.start,
          end: pageParams.end,
        },
        cancelToken: source?.token,
      });
    } else {
      response = await AxiosInstance.get("/order-details/?search", {
        params: {
          type: "contains",
          pattern: pattern,
          state: state,
          sort_by: sortParams?.sort_by,
          sort_type: sortParams?.sort_type,
        },
      });
    }
  } else {
    if (source) {
      response = await AxiosInstance.get("/order-details/?search", {
        params: {
          type: "contains",
          pattern: pattern,
          sort_by: sortParams?.sort_by,
          sort_type: sortParams?.sort_type,
          start: pageParams.start,
          end: pageParams.end,
        },
        cancelToken: source?.token,
      });
    } else {
      response = await AxiosInstance.get("/order-details/?search", {
        params: {
          type: "contains",
          pattern: pattern,
          sort_by: sortParams?.sort_by,
          sort_type: sortParams?.sort_type,
        },
      });
    }
  }
  if (!response?.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

// const getFilteredOrders = async (
//   filter,
//   params,
//   sortParams,
//   state,
//   priority,
//   source = undefined
// ) => {
//   let response;
//   if (source) {
//     if (state && filter && params && sortParams) {
//       let tempFilter = filter;
//       tempFilter = tempFilter.concat({ type: "status", status: state });
//     }
//     response = await AxiosInstance.post(
//       `/orders/filter/?sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}&start=${params.start}&end=${params.end}`,
//       filter,
//       { cancelToken: source?.token }
//     );
//   }

//   if (params && !source) {
//     const start = (params.page - 1) * params.size;
//     const end = start + params.size * 1;
//     let tempFilter = filter;

//     if (state)
//       tempFilter = tempFilter.concat({ type: "status", status: state });

//     if (priority) tempFilter = tempFilter.concat({ type: "priority" });

//     response = await AxiosInstance.post(
//       `/orders/filter/?sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}&start=${start}&end=${end}`,
//       tempFilter
//     );
//   } else if (filter && sortParams && !source) {
//     let tempFilter = filter;
//     if (state) {
//       tempFilter = tempFilter.concat({ type: "status", status: state });
//     }
//     // if (source) {
//     //   response = await AxiosInstance.post(
//     //     `/orders/filter/?sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}`,
//     //     tempFilter, { cancelToken: source?.token }
//     //   );
//     // }
//     //  else {
//     response = await AxiosInstance.post(
//       `/orders/filter/?sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}`,
//       tempFilter
//     );
//     // }
//   } else {
//     response = response = await AxiosInstance.post("/orders/filter/", filter);
//   }
//   if (!response.data.error) {
//     return response.data;
//   } else {
//     return Promise.reject(response);
//   }
// };
const getFilteredOrders = async (
  filter,
  params,
  sortParams,
  state,
  priority,
  source = undefined,
  searchedValue
) => {
  let response;
  let tempFilter = [...filter];
  if (state) {
    tempFilter = tempFilter.concat({ type: "status", status: state });
  }
  if (priority) {
    tempFilter = tempFilter.concat({ type: "priority" });
  }

  // Build base URL
  let url = `/orders/filter/`;

  // Add search params if provided
  if (searchedValue) {
    url += `?search&type=contains&pattern=${encodeURIComponent(searchedValue)}`;
  } else {
    url += `?`;
  }

  // Add sorting + pagination if available
  if (sortParams && !source) {
    if (params) {
      const start = (params.page - 1) * params.size;
      const end = start + params.size;
      url += `&sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}&start=${start}&end=${end}`;
    } else {
      url += `&sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}`;
    }
  }

  // API call with optional cancel token
  if (source) {
    response = await AxiosInstance.post(url, tempFilter, {
      cancelToken: source?.token,
    });
  } else {
    response = await AxiosInstance.post(url, tempFilter);
  }

  // Handle API response
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const changeOrderPriority = async (body) => {
  const response = await AxiosInstance.put("/orders/prioritize/", body);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const getFilteredDeckleOrders = async (
  filter,
  params,
  sortParams,
  type,
  pageParams,
  source = undefined
) => {
  let response;
  if (params) {
    const start = (params.page - 1) * params.size;
    const end = start + params.size * 1;
    response = type
      ? await AxiosInstance.post(
          `/deckle-match-orders/filter/?decklematch_orders&type=${type}&sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}&start=${start}&end=${end}`,
          filter
        )
      : await AxiosInstance.post(
          `/deckle-match-orders/filter/?decklematch_orders&sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}&start=${start}&end=${end}`,
          filter
        );
  } else if ((filter, sortParams && !source)) {
    response =
      type && (type !== "incomplete_orders" || type == "planned_orders")
        ? await AxiosInstance.post(
            `/deckle-match-orders/filter/?decklematch_orders&type=${type}&sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}`,
            filter,
            { cancelToken: source?.token }
          )
        : await AxiosInstance.post(
            `/deckle-match-orders/filter/?decklematch_orders&sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}`,
            filter,
            { cancelToken: source?.token }
          );
  } else {
    if (source) {
      response = await AxiosInstance.post(
        `/deckle-match-orders/filter/?decklematch_orders&type=${type}&sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}&start=${pageParams.start}&end=${pageParams.end}`,
        // `/deckle-match-orders/filter/?decklematch_orders&type=${type}&start=${pageParams.start}&end=${pageParams.end}`,
        filter,
        { cancelToken: source?.token }
      );
    } else {
      response = await AxiosInstance.post(
        "/deckle-match-orders/filter/?decklematch_orders",
        filter
      );
    }
  }
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const getApprovedOrdersList = async (
  params,
  sortParams,
  state,
  source = undefined
) => {
  let response;
  const start = (params?.page - 1) * params?.size;
  const end = start + params?.size * 1;
  // if (!params) response = await AxiosInstance.get("/approve-order-details/");
  if (source) {
    if (state && params && sortParams) {
      response = await AxiosInstance.get(
        `/approve-order-details/?state=${state}&sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}&start=${params.start}&end=${params.end}`
      );
    } else {
      response = await AxiosInstance.get(
        `/approve-order-details/?sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}&start=${params.start}&end=${params.end}`
      );
    }
  } else if (state && sortParams && !source) {
    response = await AxiosInstance.get(
      `/approve-order-details/?state=${state}&start=${start}&end=${end}&sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}`
    );
  } else if (sortParams && !source) {
    response = await AxiosInstance.get(
      `/approve-order-details/?start=${start}&end=${end}&sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}`
    );
  } else if (state && !source) {
    // if(source)
    // response = await AxiosInstance.get(`/approve-order-details/?state=${state}`, {cancelToken: source?.token});
    // else
    response = await AxiosInstance.get(
      `/approve-order-details/?state=${state}`
    );
  } else if (!params && !source) {
    response = await AxiosInstance.get("/approve-order-details/");
  } else {
    response = await AxiosInstance.get(
      `/approve-order-details/?start=${start}&end=${end}`
    );
  }
  if (!response.data.error) {
    response.data.data["state"] = state;
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

const getFilteredApproveOrders = async (
  filter,
  params,
  sortParams,
  state,
  priority,
  source = undefined
) => {
  let response;
  if (params && !source) {
    const start = (params.page - 1) * params.size;
    const end = start + params.size * 1;
    let tempFilter = filter;

    if (state)
      tempFilter = tempFilter.concat({ type: "status", status: state });

    if (priority) tempFilter = tempFilter.concat({ type: "priority" });

    response = await AxiosInstance.post(
      `/approve-orders/filter/?sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}&start=${start}&end=${end}`,
      tempFilter
    );
  } else if (filter && sortParams && !source) {
    let tempFilter = filter;
    tempFilter = tempFilter.concat({ type: "status", status: state });
    if (source) {
      response = await AxiosInstance.post(
        `/approve-orders/filter/?sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}`,
        tempFilter,
        { cancelToken: source?.token }
      );
    } else {
      response = await AxiosInstance.post(
        `/approve-orders/filter/?sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}`,
        tempFilter
      );
    }
  } else if (filter && params && sortParams && state && source) {
    let tempFilter = filter;
    tempFilter = tempFilter.concat({ type: "status", status: state });
    response = response = await AxiosInstance.post(
      `/approve-orders/filter/?sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}&start=${params.start}&end=${params.end}`,
      tempFilter,
      { cancelToken: source?.token }
    );
  } else {
    let tempFilter = filter;
    tempFilter = tempFilter.concat({ type: "status", status: state });
    response = response = await AxiosInstance.post(
      "/approve-orders/filter/",
      tempFilter
    );
  }

  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const searchApproveOrderRecords = async (
  pattern = "",
  state,
  source = undefined,
  sortParams = {},
  pageParams = {}
) => {
  let response;
  if (state) {
    if (source) {
      response = await AxiosInstance.get("/approve-order-details/?search", {
        params: {
          type: "contains",
          pattern: pattern,
          state: state,
          start: pageParams.start,
          end: pageParams.end,
          sort_by: sortParams.sort_by,
          sort_type: sortParams.sort_type,
        },
        cancelToken: source?.token,
      });
    } else {
      response = await AxiosInstance.get("/approve-order-details/?search", {
        params: {
          type: "contains",
          pattern: pattern,
          state: state,
        },
      });
    }
  } else {
    if (source) {
      response = await AxiosInstance.get("/approve-order-details/?search", {
        params: {
          type: "contains",
          pattern: pattern,
          start: pageParams.start,
          end: pageParams.end,
          sort_by: sortParams.sort_by,
          sort_type: sortParams.sort_type,
        },
        cancelToken: source?.token,
      });
    } else {
      response = await AxiosInstance.get("/approve-order-details/?search", {
        params: {
          type: "contains",
          pattern: pattern,
        },
      });
    }
  }
  if (!response?.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const updateOrdersInBulk = async (requestArray) => {
  const response = await AxiosInstance.put(
    "/incomplete-orders/?bulk",
    requestArray
  );
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

// const saveUploadedOrders = async (data) => {
//   const response = await AxiosInstance.post(
//     "/orders/imports/general/upload/",
//     data
//   );
//   if (!response.data.error) {
//     return response.data;
//   } else {
//     return Promise.reject(response.message);
//   }
// };
const saveUploadedOrders = async (data,format) => {
  const response = await AxiosInstance.post(
    format==='format_5'||format==='format_6'?'orders/imports/aps/general/upload/':"/orders/imports/general/upload/",
    data
  );
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }
};
export const notifyUploadedOrders = async (data) => {
  const response = await AxiosInstance.post(
    "orders/imports/general/upload/?notify",
    data
  );
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }
};
export const saveConflictingOrders = async (data,source) => {
  source=undefined
  let response
  if(source){
   response = await AxiosInstance.post("orders/erp/?bulk&add", data,{cancelToken: source?.token}
);
  }
  else{
  response = await AxiosInstance.post("orders/erp/?bulk&add", data);
  }
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }
}

const getSplitGroupOrders = async (groupId) => {
  const response = await AxiosInstance.get("/split-group/orders/", {
    params: { id: groupId },
  });
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

const saveSplitOrder = async (data) => {
  const response = await AxiosInstance.post("/orders/split/", data);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }
};

const sheetMatchingSplitOrder = async (data) => {
  const response = await AxiosInstance.post(
    "/orders/split/?rewinderless",
    data
  );
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }
};

const getOrdersByOrderNos = async (ids) => {
  const response = await AxiosInstance.post("/order-details/?get", {
    orders: ids,
  });
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const mergeOrders = async (data) => {
  const response = await AxiosInstance.post("/orders/merge/", data);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const mergeOrdersForSheetMatching = async (data) => {
  const response = await AxiosInstance.post("orders/merge/?rewinderless", data);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const addOrRemoveOrdersFromGroup = async (data, type) => {
  const param = type === "new_solution" ? "?new_solution" : "";
  const response = await AxiosInstance.put(
    `/jobcards/machine-selection/add-remove-orders/${param}`,
    data
  );

  return response;
};

const getOrderHistoryById = async (code, sort) => {
  const start = (sort.page - 1) * sort.size;
  const end = start + sort.size * 1;
  const response = await AxiosInstance.get(
    `/orders/history/?number=${code}&start=${start}&end=${end}`
  );
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const searchOrderHistory = async (number, pattern) => {
  const response = await AxiosInstance.get(
    `/orders/history/?number=${number}&search&type=contains&pattern=${pattern}`
  );
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

const getAllDeckleMatchingOrdersListByOrderno = async (orderNo = "") => {
  const response = await AxiosInstance.get("/deckle-match-order-details/", {
    params: { number: orderNo },
  });
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const getProductionDetailsForOrder = async (orderNo = "") => {
  const response = await AxiosInstance.get(
    `/order-details/?number=${orderNo}&production_details`
  );
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const getCount = async () => {
  const response = await AxiosInstance.get("/order-details/?count");
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const getPendingOrderDetailsById = async (id = "") => {
  const response = await AxiosInstance.get(`/orders/pending-details/?id=${id}`);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const getPackagingList = async (type, status = "") => {
  let response;
  if(type && status){
    response = await AxiosInstance.get(`packaging-config/?${type}&status=${status}`);
  } else if(status){
    response = await AxiosInstance.get(`packaging-config/?&status=${status}`);
  } else {
    response = await AxiosInstance.get(`packaging-config/?${type}`);
  }
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const cancelOrderQuantity = async (data, id) => {
  const response = await AxiosInstance.put(`/orders/cancel/?id=${id}`, data);
  return response;
};
export const editQtyToBePlannedForReviewOrder = async (body, type) => {
  // console.log(body, type);
  const param = type === "new_solution" ? "&new_solution" : "";
  const res = await AxiosInstance.put(
    `/jobcards/machine-selection/quality/?orders${param}`,
    body
  );
  if (!res.data.error) {
    return res;
  } else {
    return Promise.reject(res);
  }
};
export const changePriorityofGroupOrder = async (body) => {
  const response = await AxiosInstance.put("jobcards/machine-selection/prioritize-orders/", body);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
}
export const getProcessedQtyDetails = async (id) => {
  const response = await AxiosInstance.get(`/orders/processed-details/?id=${id}`);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const getPendingQtyDetails = async (id) => {
  const response = await AxiosInstance.get(`/orders/pending-details/?id=${id}`);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
  };

  export const addSo = async (body = {}) => {
    const response = await AxiosInstance.post(`/sos/`, body);
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  };
  export const updateSo = async (soNumber,body = {}) => {
    const response = await AxiosInstance.put(`/sos/?number=${soNumber}`, body);
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  };
  export const getAllOrdersListBySono = async (soNo = "") => {
    const response = await AxiosInstance.get("/order-details/", {
      params: { so: soNo },
    });
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  };
  export const getSoDetails = async (value) => {
    const response = await AxiosInstance.get(`/sos/?number=${value}`);
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  };


  const getOrdersListForCreateNewSol = async (body, pattern) => {
  //const searchParams = { orders: value };
  if(pattern)
  {
    const response = await AxiosInstance.post(
    `/deckle-match-order-details/?group_orders&search&pattern=${pattern}`,
    body
  );
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
  }
  else
  {
const response = await AxiosInstance.post(
    `/deckle-match-order-details/?group_orders`,
    body
  );
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
  }
  
};

export const getERPOrders = async (
  source=undefined,
  fetchType
) => {
  let response
  if(source){
    response = await AxiosInstance.post(`orders/erp/`, {type:fetchType}, {cancelToken:source.token});
  }
  else{
    response = await AxiosInstance.post(`orders/erp/`,{type:fetchType});
  }
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  };

export {
  getOrderDetails,
  getPosData,
  getPosDetails,
  editPo,
  addPo,
  getOrdersData,
  getOrdersList,
  getAllOrders,
  getDeckleOrderDetails,
  getAllOrdersList,
  getAllOrdersListByOrderno,
  getAllOrdersListByPono,
  rejectOrApproveOrder,
  updateOrder,
  deleteOrder,
  deletePo,
  bulkChangeOrderState,
  postOrder,
  addDummyOrders,
  poExists,
  getDeckleOrderByPo,
  searchOrderRecords,
  getFilteredOrders,
  //bulkApproveOrders,
  changeOrderPriority,
  getDeckleOrdersList,
  getFilteredDeckleOrders,
  getApprovedOrdersList,
  getFilteredApproveOrders,
  searchApproveOrderRecords,
  updateOrdersInBulk,
  updateIncompleteOrder,
  saveUploadedOrders,
  getSplitGroupOrders,
  saveSplitOrder,
  getOrdersByOrderNos,
  mergeOrders,
  addOrRemoveOrdersFromGroup,
  getOrderHistoryById,
  searchOrderHistory,
  getAllDeckleMatchingOrdersListByOrderno,
  getProductionDetailsForOrder,
  sheetMatchingSplitOrder,
  mergeOrdersForSheetMatching,
  getCount,
  getPendingOrderDetailsById,
  cancelOrderQuantity,
  getPackagingList,
  restoreOrder,
  getOrdersListForCreateNewSol
};

